<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <div :class="{workspace:true, mobile: $api.isMobile(), desktop: !$api.isMobile()}" v-if="currentUser">

    <app-side-bar v-if="!$api.isMobile()"/>

    <!--b-navbar toggleable="lg" style="background: #232934">

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>

            <time-logger-status/>

        </b-collapse>

    </b-navbar!-->

    <div v-if="!loaded" class="loading">Loading...</div>

    <router-view v-else></router-view>

    <ActionsChecker></ActionsChecker>
    <!-- Footer -->

  </div>

</template>

<script>

// Import time logger
import AppSideBar from "../components/AppSideBar";
import ActionsChecker from "../pages/HR/Actions/ActionsChecker";

export default {

  // Register components
  components: {AppSideBar, ActionsChecker},

  watch: {
    'messagesCount': 'updateTitle'
  },

  // Data
  data() {
    return {
      loaded: false
    }
  },

  // App mounted
  mounted() {

    // Set task list mode
    this.$dispatch('tree/setTaskListMode', 'task-list')

    // Check for current user
    if (!this.currentUser) {
      this.$router.replace({name: 'login'});
      return;
    }

    // Promises
    let proms = [];

    // Auth on content
    //proms.push(this.$dispatch('content/auth'));

    // Load user positions
    proms.push(this.$dispatch('auth/loadUserPositions'));

    // Load workspace positions
    this.$dispatch('wspositions/loadPositions');

    // Wait for loading
    Promise.all(proms).then(() => {

      // Loaded
      this.loaded = true;
    });
  },

  methods: {

    /**
     * Update app title
     */

    updateTitle() {
      window.document.title = '3proj' + (this.messagesCount ? (" (" + this.messagesCount + " new messages)") : "");
    }
  },

  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },

    /**
     * Unreaded message count
     */
    messagesCount() {
      return this.$get("notifications/getUsersComments").length
    }
  }
}

</script>

<style lang="scss">
@import './src/sass/public.scss';
</style>
